// extracted by mini-css-extract-plugin
export default {"layout":"MainLayout_layout__gDoZC","main":"MainLayout_main__FMkKa"};